const imageRatioCalculationMap = {
  '1:1': 1,
  '9:16': 0.5625,
  '16:9': 1.7777777777777777,
  '16:9/2': 3.55555555556,
  '3:4': 0.75,
  '4:3': 1.33333333333,
} as const;

type ImageRatioCalculationMap = typeof imageRatioCalculationMap;

type RatioKeys = keyof ImageRatioCalculationMap;

type RateObject = {
  mobile: RatioKeys;
  tablet: RatioKeys;
  desktop: RatioKeys;
};

type Ratio = RatioKeys | RateObject;

type ImageElementCSSVars = '--ratio-mobile' | '--ratio-tablet' | '--ratio-desktop';

type ImageElementStyle = {
  [key in ImageElementCSSVars]: number;
} & React.CSSProperties;

type ImageElementData = {
  url: string;
  description?: string | null;
};

export { imageRatioCalculationMap };
export type { ImageElementData, ImageElementStyle, RateObject, Ratio };
